import MuiFormControlLabel from '@mui/material/FormControlLabel';
import type { ComponentPropsWithoutRef, ComponentRef } from 'react';
import { forwardRef } from 'react';

type FormControlLabelProps = ComponentPropsWithoutRef<
  typeof MuiFormControlLabel
>;
type FormControlLabelRef = ComponentRef<typeof MuiFormControlLabel>;

const FormControlLabel = forwardRef<FormControlLabelRef, FormControlLabelProps>(
  (props, ref) => {
    return <MuiFormControlLabel ref={ref} {...props} />;
  },
);
FormControlLabel.displayName = 'FormControlLabel';
export default FormControlLabel;
